import {EP_DEFAULT_FIXED_SIZE, renderSettings} from '../../rendering/render.def';

export type EditorFaceInput = {
    isSingleDoc: boolean;
    epWidth: number;
    epHeight: number;
    plateWidthPt?: number;
    plateHeightPt?: number;
    docWidth?: number;
    docHeight?: number;
};

const positive = (value: number | undefined): number => (value != null && value > 0 ? value : 0);

/** Inches for the Quill box. A missing size used to leave the box at 0×0, so there was nothing to type in. */
export const editorFaceInches = (input: EditorFaceInput): {width: number; height: number} => {
    if (input.isSingleDoc) {
        const fromPlateWidth = positive(input.plateWidthPt) / 72;
        const fromPlateHeight = positive(input.plateHeightPt) / 72;

        return {
            width: fromPlateWidth || positive(input.epWidth) || positive(input.docWidth) || EP_DEFAULT_FIXED_SIZE.width,
            height: fromPlateHeight || positive(input.epHeight) || positive(input.docHeight) || 2,
        };
    }

    return {
        width: positive(input.epWidth) || EP_DEFAULT_FIXED_SIZE.width,
        height: positive(input.epHeight) || EP_DEFAULT_FIXED_SIZE.height,
    };
};

/**
 * Inches to store from a dynamic editor measurement. A collapsed plate panel reports no
 * scroll height, and treating that as 1px stores about half an inch and locks the box there.
 */
export const dynamicMeasuredHeightInches = (scrollHeightPx: number): number | null => {
    if (!(scrollHeightPx > 0)) {
        return null;
    }

    return (Math.max(scrollHeightPx, 1) + renderSettings.defaultPadding + renderSettings.topPadding) / renderSettings.referenceDPI;
};
